import React, { Suspense, memo } from "react";
import { iconRegistry } from "@components/Icon/iconRegistry";

type IconName = keyof typeof iconRegistry;

interface IconProps extends React.SVGProps<SVGSVGElement> {
    name: IconName;
    className?: string;
    width?: number | string;
    height?: number | string;
    fill?: string;
    title?: string;
    as?: React.ElementType;
    viewBox?: string;
}

const Icon: React.FC<IconProps> = memo(
    ({
        name,
        className = "fill-dark-60",
        width = "16",
        height = "16",
        fill = "",
        title,
        as: Component = "svg",
        viewBox = "0 0 32 32",
        ...props
    }) => {
        const IconComponent = iconRegistry[name] || iconRegistry["default"];
        const ariaLabel = title || name;

        return (
            <Suspense fallback={<span className="inline-block" style={{ width, height }} />}>
                <Component
                    xmlns="http://www.w3.org/2000/svg"
                    className={className}
                    width={width}
                    height={height}
                    fill={fill}
                    viewBox={viewBox}
                    aria-label={ariaLabel}
                    role={title ? "img" : "presentation"}
                    {...props}
                >
                    {title && <title>{title}</title>}
                    <IconComponent /> {className}
                </Component>
            </Suspense>
        );
    }
);

export default Icon;
